import { type FC, useState } from "react"
import styled from "styled-components"

import Checkbox from "~/components/Checkbox"
import { componentBackgroundColor, componentBorderColor } from "~/utilities/styles"

type Props = { option: { id: string; label: string }; isChecked: boolean; setChecked(value: boolean): Promise<void> }
const Notification: FC<Props> = ({ option, isChecked, setChecked }) => {
	const [isSubmitting, setSubmitting] = useState(false)

	return (
		<Container key={option.id}>
			<NotificationLabel>{option.label}</NotificationLabel>
			<Actions>
				<Checkbox
					ariaLabel={option.label}
					isChecked={isChecked}
					isLoading={isSubmitting}
					onChange={async value => {
						setSubmitting(true)
						try {
							await setChecked(value)
						} catch (error) {
							console.error(error)
							setSubmitting(false)
						}
						setSubmitting(false)
					}}
				/>
			</Actions>
		</Container>
	)
}

const Container = styled.div`
	background-color: ${componentBackgroundColor};
	border: 1px solid ${componentBorderColor};
	border-radius: 24px;
	padding: 24px;
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	gap: 16px;
`

const NotificationLabel = styled.h2`
	font-weight: 600;
	font-size: 18px;
	text-align: left;
`

const Actions = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
`

export default Notification
